"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MainArea = exports.InteractiveArea = exports.FooterArea = exports.Column = void 0;
var _SlotSizes = require("./SlotSizes.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
var _index = require("../../styles/index.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var InteractiveArea = exports.InteractiveArea = _styledComponents["default"].div.withConfig({
  displayName: "Areas__InteractiveArea",
  componentId: "sc-1tea2mc-0"
})(["& button,& a,& [role='button'],& [role='link']{position:relative;z-index:1;}"]);
var MainArea = exports.MainArea = (0, _styledComponents["default"])(InteractiveArea).withConfig({
  displayName: "Areas__MainArea",
  componentId: "sc-1tea2mc-1"
})(["", ""], function (_ref) {
  var $horizontalGap = _ref.$horizontalGap;
  return (0, _styledComponents.css)(["column-gap:", ";align-items:center;display:flex;"], (0, _index.isSpacer)($horizontalGap) ? (0, _index.cssSpacing)($horizontalGap) : $horizontalGap);
});
var Column = exports.Column = (0, _styledComponents["default"])(InteractiveArea).withConfig({
  displayName: "Areas__Column",
  componentId: "sc-1tea2mc-2"
})(["", ""], function (_ref2) {
  var $size = _ref2.$size,
    _ref2$$titleGap = _ref2.$titleGap,
    $titleGap = _ref2$$titleGap === void 0 ? _SlotSizes.titleSpacing[$size] : _ref2$$titleGap;
  return (0, _styledComponents.css)(["display:flex;flex-direction:column;gap:", ";flex-basis:100%;align-items:flex-start;"], (0, _index.isSpacer)($titleGap) ? (0, _index.cssSpacing)($titleGap) : $titleGap);
});
var FooterArea = exports.FooterArea = (0, _styledComponents["default"])(InteractiveArea).withConfig({
  displayName: "Areas__FooterArea",
  componentId: "sc-1tea2mc-3"
})(["margin-top:auto;"]);